import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SearchQuery, CrowdLevel, HistoryEntry } from '../types';

interface HistoryStore {
  entries: HistoryEntry[];
  add: (query: SearchQuery, resultLevel: CrowdLevel) => void;
  clear: () => void;
}

export const useHistoryStore = create<HistoryStore>()(
  persist(
    (set) => ({
      entries: [],
      add: (query, resultLevel) =>
        set((s) => ({
          entries: [
            {
              id: crypto.randomUUID(),
              query,
              result_level: resultLevel,
              searched_at: new Date().toISOString(),
            },
            ...s.entries,
          ].slice(0, 20),
        })),
      clear: () => set({ entries: [] }),
    }),
    { name: 'idanroh-history' }
  )
);
